import React, { useState } from 'react';

import type { Tag } from '../../../../core/data-sources/frapi/data-types.js';

import { FilterButton } from './FilterButton.js';
import { useOutsideClick } from '../../../../core/react/hooks/index.js';
import { formatTag } from './helpers.js';

export interface DropdownProps {
  setFilter: (filter: Tag) => void;
  filters: Tag[];
  activeFilters: Tag[];
}

export const Dropdown: React.FC<DropdownProps> = ({
  setFilter,
  filters,
  activeFilters,
}) => {
  const [dropdownActive, setDropdownActive] = useState(false);
  const handleClickOutside = () => {
    setDropdownActive(false);
  };
  const containerRef = useOutsideClick(handleClickOutside);

  return (
    <div ref={containerRef} className="dropdown-wrapper">
      <button
        aria-label="Vis flere"
        className={`dropdown-button ${dropdownActive ? 'active' : 'inactive'}`}
        onClick={() => {
          setDropdownActive(!dropdownActive);
        }}
      >
        Velg områder
      </button>
      {dropdownActive && (
        <ul className="dropdown-tag-container">
          {filters.map((t, j) => (
            <li key={`tag-item-${j}`}>
              <button
                className={`dropdown-item ${
                  activeFilters.some((a) => t.id === a.id)
                    ? 'active'
                    : 'inactive'
                }`}
                onClick={() => setFilter(t)}
              >
                {formatTag(t.title)}
              </button>
            </li>
          ))}
        </ul>
      )}
      {activeFilters.length > 0 && (
        <div className="active-drop-down-filter-container">
          {activeFilters.map((f, i) => (
            <FilterButton
              key={`active-drop-down-${i}`}
              tag={f}
              handleClick={setFilter}
              active
            />
          ))}
        </div>
      )}
    </div>
  );
};
